<div class="first-row">   
</div>
<div class="second-row">
    {{'app.welcome' | translate}}
</div>